<template>
  <div class="card-list-body">
    <template v-if="isBoardDetail">
      <div
        v-for="item in list"
        :key="item.cardId"
        class="list-item"
      >
        <card-image :feed="item" />
      </div>
    </template>
    <masonry v-else :width="width" :gutter="useMobileUI ? 9 : 10">
      <masonry-item
        v-for="item in list"
        :key="item.cardId"
      >
        <card-text v-if="isTextCard(item)" :feed="item" />
        <card-full-image v-else :feed="item" :width="useMobileUI ? 166 : 288" />
      </masonry-item>
    </masonry>
  </div>
</template>

<script>
import { isTextCard } from '@/utils/utils';

import Masonry from '@/components/Masonry/Masonry';
import MasonryItem from '@/components/Masonry/MasonryItem';
import CardText from '@/components/Card/CardText';
import CardImage from '@/components/Card/CardImage';
import CardFullImage from '@/components/Card/CardFullImage';

export default {
  name: 'TongrenList',

  components: {
    Masonry,
    MasonryItem,
    CardText,
    CardImage,
    CardFullImage
  },

  props: {
    list: {
      type: Array,
      default: () => ([])
    }
  },

  computed: {
    width() {
      // 按屏幕比计算出对应的单列宽度
      return this.useMobileUI ? 178 / 375 * document.documentElement.offsetWidth : 300;
    }
  },

  methods: {
    isTextCard
  }
};
</script>
